module.exports = __webpack_public_path__ + "img/small_truck_black.eb271e03.svg";